import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../stores/CurrentUserStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { API, PaginatedPayment, PaymentFilter, PermissionNames } from '@getgreenline/homi-shared'
import { LoadingAnimation } from '../../components/LoadingAnimation'
import { ExpandablePayment } from '../../components/ExpandablePayment'

interface Props {
  filter: PaymentFilter
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
  onClose: () => void
}

interface State {
  payments?: PaginatedPayment
  isLoading: boolean
}

// For viewing purposes only, not editing
@inject('currentCompanyStore', 'currentUserStore')
@observer
export class PaymentListModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  componentDidMount() {
    this.search()
  }

  search() {
    const company = this.props.currentCompanyStore!.company!
    this.setState({ isLoading: true })
    API.getPayments(company.id, this.props.filter)
      .then((paginatedPayments) => {
        this.setState({
          payments: paginatedPayments,
          isLoading: false,
        })
      })
      .catch((error) => {
        this.setState({ isLoading: false })
      })
  }

  render() {
    const filter = this.props.filter

    let body: JSX.Element
    const payments = this.state.payments

    const company = this.props.currentCompanyStore!.company!
    const canEditCustomers = this.props.currentUserStore!.hasPermissionAtEntity(
      PermissionNames.CAN_EDIT_CUSTOMERS,
      company.id,
    )

    if (!payments) {
      body = <LoadingAnimation />
    } else {
      body = (
        <div className='table-responsive'>
          <table className='table table-hover'>
            <thead className='thead-light'>
              <tr>
                <th>ID</th>
                <th>Complete Date</th>
                <th>Source</th>
                <th>Device</th>
                <th>Payment</th>
                <th>Employee</th>
                <th>Customer</th>
                <th>Notes</th>
                <th className='text-right'>Barcode</th>
                <th className='text-right'>Total</th>
                <th className='text-right'>Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.payments.map((payment) => {
                return (
                  <ExpandablePayment
                    key={payment.id}
                    payment={payment}
                    currentEmployeeId={null}
                    canEdit={false}
                    canRefund={false}
                    hideButtons
                    onUpdate={() => this.search()}
                    canEditCustomer={canEditCustomers}
                  />
                )
              })}
            </tbody>
          </table>
          <br />
          <div>
            <button
              className='btn btn-light w-100'
              disabled={this.state.isLoading}
              onClick={() => {
                filter.setLimit(filter.limit + 30)
                this.search()
              }}
            >
              {this.state.isLoading ? 'Loading...' : 'Show more'}
            </button>
          </div>
        </div>
      )
    }

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()} size='xl'>
        <ModalHeader toggle={() => this.props.onClose()}>Sales</ModalHeader>
        <ModalBody>{body}</ModalBody>
      </Modal>
    )
  }
}
